import { createLazyFileRoute } from "@tanstack/react-router";

import { RequisitionPreviewPage } from "@/features/accession/routes/AccessionRequisition";

export const Route = createLazyFileRoute(
  "/_auth/_app/accessions_/$id/requisition",
)({
  component: RequisitionPreviewPage,
});
